import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { shellPathEntriesEnabled } from './shellPathEntries'
import { UnifiedShell } from './unified/UnifiedShell'
import { UnmatchedDeployPath } from './UnmatchedDeployPath'

export function UnifiedApp() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<UnifiedShell />} />
        {shellPathEntriesEnabled() ? (
          <>
            <Route path="/legacy/:token" element={<UnifiedShell pathExperience="legacy" />} />
            <Route path="/new/:token" element={<UnifiedShell pathExperience="new" />} />
          </>
        ) : null}
        <Route path="/:token" element={<UnifiedShell />} />
        <Route path="*" element={<UnmatchedDeployPath />} />
      </Routes>
    </BrowserRouter>
  )
}
